import { render } from "./confirmReserveComponent.vue?vue&type=template&id=e73bbe36"
import script from "./confirmReserveComponent.vue?vue&type=script&lang=js"
export * from "./confirmReserveComponent.vue?vue&type=script&lang=js"

import "./confirmReserveComponent.vue?vue&type=style&index=0&id=e73bbe36&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__